import { render, staticRenderFns } from "./IntakeForm.vue?vue&type=template&id=29573322&scoped=true"
import script from "./IntakeForm.vue?vue&type=script&lang=js"
export * from "./IntakeForm.vue?vue&type=script&lang=js"
import style0 from "./IntakeForm.vue?vue&type=style&index=0&id=29573322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29573322",
  null
  
)

export default component.exports